module.exports = __webpack_public_path__ + "img/sponsors.b55d68c0.png";